import { defineComponent as _defineComponent } from 'vue'
import WizardStep from '@/components/wizard/WizardStep.vue';
import { computed } from 'vue';
import useVuelidate from '@vuelidate/core';
import { useI18n } from '@/composables/i18n';
import { StandardAlertFormData } from '@/components/alerts/model';
import { required, withLocalizedValidators } from '@/utils/validation';
import AlertSeveritySelect from '@/components/inputs/AlertSeveritySelect.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneralDataWizardStep',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: StandardAlertFormData) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: StandardAlertFormData;
};





const formData = computed<StandardAlertFormData>({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const validations = {
  name: withLocalizedValidators('e_service_center.standard_alerts.name', {
    required,
  }),
  severity: { required },
};
const v$ = useVuelidate(validations, formData);

function updateField(field: string, value: any) {
  formData.value = { ...formData.value, [field]: value };
}

function getValidationMessage(key: keyof StandardAlertFormData) {
  return v$.value[key]?.$errors[0]?.$message;
}

const { t } = useI18n();

return { __sfc: true,props, emit, formData, validations, v$, updateField, getValidationMessage, t, WizardStep, AlertSeveritySelect }
}

})